export interface DeliveryModesParams {
    typeParcours: TypeParcoursEnums;
    typeClient: 'GP' | 'PRO';
    gencodes: string[];
    adresse: Address;
}

export enum TypeParcoursEnums {
    RENOUVELLEMENT = 'RENOUVELLEMENT',
    ACQUISITION = 'ACQUISITION',
    ACQUISITIONFIX = 'ACQUISITIONFIX',
    CONTINUITE_DE_SERVICE = 'CONTINUITE_DE_SERVICE',
    REPLACE_SIM = 'REPLACE_SIM',
    SOUSCRIPTION_OFFRE = 'SOUSCRIPTION_OFFRE_ADDITIONNELLE',
}

export interface Address {
    codePostal: string;
}

export interface DeliveryModesResult {
    adresse: Address;
    modesLivraison: DeliveryMode[];
}

export interface DeliveryMode {
    gencode: string;
    libelle: string;
    dateLivraisonEstimee: string;
    dateLivraisonEstimeeAuPlusTard: string;
    prix: number;
}
